import { MdContrast } from "react-icons/md";
import { useAccessibility } from "../../../context/AccessibilityContext";

const HighContrast = () => {
  const { settings, updateSetting } = useAccessibility();
  const enabled = settings.highContrast;

  return (
    <div className="p-8 max-w-2xl space-y-6">
      <div className="flex items-center gap-3">
        <MdContrast className="text-4xl text-blue-900 flex-shrink-0" />
        <div>
          <h2 className="text-xl font-bold text-blue-950">Alto Contraste</h2>
          <p className="text-sm text-gray-500 mt-0.5">
            Aumenta o contraste visual para facilitar a leitura em condições de baixa visibilidade.
          </p>
        </div>
      </div>

      {/* Control */}
      <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-blue-950 text-sm">Ativar Alto Contraste</p>
            <p className="text-xs text-gray-500 mt-0.5">
              {enabled
                ? "O alto contraste está ativado em todo o portal."
                : "O modo padrão está ativo."}
            </p>
          </div>
          <button
            onClick={() => updateSetting("highContrast", !enabled)}
            role="switch"
            aria-checked={enabled}
            aria-label="Alternar alto contraste"
            className={`relative inline-flex h-7 w-14 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
              enabled ? "bg-blue-600" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-6 w-6 rounded-full bg-white shadow-md transform transition-transform ${
                enabled ? "translate-x-7" : "translate-x-0.5"
              }`}
            />
          </button>
        </div>
      </div>

      {/* Preview */}
      <div>
        <p className="text-xs text-gray-400 uppercase font-semibold tracking-wider mb-3">
          Pré-visualização
        </p>
        <div className="grid grid-cols-2 gap-4">
          <div className="rounded-2xl border border-gray-200 p-5 bg-white space-y-2">
            <p className="text-xs text-gray-400 font-medium">Padrão</p>
            <p className="font-bold text-blue-950 text-base">Prefeitura de Serrinha</p>
            <p className="text-sm text-gray-600 leading-relaxed">
              Portal oficial com informações sobre serviços e transparência pública.
            </p>
            <span className="inline-block text-xs bg-blue-600 text-white rounded-full px-3 py-1">
              Serviços
            </span>
          </div>
          <div className="rounded-2xl border border-white p-5 bg-gray-950 space-y-2" style={{ filter: "contrast(1.5) brightness(0.9)" }}>
            <p className="text-xs text-gray-400 font-medium">Alto Contraste</p>
            <p className="font-bold text-white text-base">Prefeitura de Serrinha</p>
            <p className="text-sm text-gray-300 leading-relaxed">
              Portal oficial com informações sobre serviços e transparência pública.
            </p>
            <span className="inline-block text-xs bg-yellow-400 text-gray-950 rounded-full px-3 py-1 font-bold">
              Serviços
            </span>
          </div>
        </div>
      </div>

      {/* Status indicator */}
      <div
        className={`flex items-center gap-3 p-4 rounded-xl text-sm font-medium ${
          enabled
            ? "bg-blue-600 text-white"
            : "bg-gray-100 text-gray-600"
        }`}
      >
        <MdContrast className="text-xl flex-shrink-0" />
        <span>
          {enabled ? "Alto contraste ativado — configuração salva automaticamente." : "Alto contraste desativado."}
        </span>
      </div>
    </div>
  );
};

export default HighContrast;
